import axios from 'axios';
import md5 from 'js-md5';
// import jwt_decode from "jwt-decode";
import { getLanguage, guid } from "@/utils/index";
import store from "../store/index";
import Aes from "@/utils/aes.js";
// 创建axios实例
const service = axios.create({
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  baseURL: process.env.NODE_ENV === 'production' ? 'https://gateway.qqlive.online' : '/commonApi', // api 的 base_url
  timeout: 50000, // 请求超时时间
  withCredentials: true
})

// request拦截器
service.interceptors.request.use(
  config => {
    let timer = new Date().getTime(), uid = localStorage.getItem('uid') || guid();
    config.headers['OS'] = "0";
    config.headers['X-Language'] = getLanguage(store.state.supportLanguage);
    config.headers['Accept-Language'] = getLanguage(store.state.supportLanguage);
    config.headers['X-AppVersion'] = `1.0.0.0`;
    config.headers['P-G'] = `N`;
    config.headers['appId'] = `QQlive`;
    config.headers['X-UDID'] = uid;
    config.headers['X-U'] = uid;
    config.headers['X-Timestamp'] = timer;
    config.headers['X-Sign'] = md5(`${uid}jgyh,kasd${timer}`);
    config.headers['N-L'] = "Y";

    if (localStorage.getItem('token')) {
      config.headers['Authorization'] = `HSBox ${localStorage.getItem('token')}`;
    }

    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const code = response.status
    if (String(code) !== '200') {
      return Promise.reject('error');
    } else {
      return response.data;
    }
  },
  error => {
    let code = (error.response.data && error.response.data.code) || 0;
    let msg = (error.response.data && error.response.data.msg) || (error.response.data && error.response.data.desc) || "";
    if (code == 991 || code == 992) {
      // 退出后个人数据需要清除
      store.commit("setState", { member: null });
      localStorage.removeItem("token");
      router.replace("/login");
    }

    if (msg) {
      Toast(msg);
    }
    return Promise.reject(error)
  }
)
export default service
